import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Experience } from '../../core/models';
import { EsperienzeListConfig, AuthService, WMAIApiService, AppInformationService, ExpLocalStorage } from '../../core';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { Angulartics2 } from 'angulartics2';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { SuiModalService, ModalSize } from 'ng2-semantic-ui';
import { SimpleModal } from '../../core/templates';

declare var $: any;

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html'
})
export class DownloadsComponent implements OnInit {
  isMapVisible = false;
  isSmallScreen: boolean = false;

  searchForm: FormGroup;
  destination: string;
  username: string;
  fromDate: Date;
  toDate: Date;
  type: string = 'private';

  filtersVisible = true;
  resultsVisible = true;

  bbox: string = "";

  results: Experience[] = [];
  resultsCount: number;
  loading = false;
  currentPage = 1;
  limit: number = 6;
  totalPages: Array<number> = [1];
  wait: number = 0;
  private: number = 0;
  public: number = 0;
  deleted: number = 0;
  archived: number = 0;
  isUserLoggedIn: boolean = false;
  savedExp: Experience[] = [];

  subscriptions: Subscription;

  connectionStatusMessage: string;
  connectionStatus: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private wgisservice: WgisService,
    private authservice: AuthService,
    private wmaiservice: WMAIApiService,
    private router: Router,
    private angulartics2: Angulartics2,
    private translateService: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private appService: AppInformationService,
    private modalService: SuiModalService,
    private explocalstorage: ExpLocalStorage
  ) {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    this.connectionStatus = appService.getCurrentConnectionStatus();
    this.isUserLoggedIn = this.authservice.isUserLoggedIn();
  }

  ngOnInit() {
    this.subscriptions = this.appService.onlineStatus.subscribe(data => {
      this.connectionStatus = data;
    });
    this.isMapVisible = this.wgisservice.getMapVisible();
    window.scrollTo(0, 0);
    this.checkCacheExp();
  }
  /**
   * controlla la cache dell'exp
   */
  checkCacheExp() {
    var exp = this.explocalstorage.getExperience();
    if (exp != null) {
      this.getCacheExp(exp);
    } else {
      if (this.appService.getCurrentConnectionStatus()) {
        let title: string = this.translateService.instant('modal.profile.noExp.title');
        let content: string = this.translateService.instant('modal.profile.noExp.error');
        this.modalService
          .open(new SimpleModal(title, content, ModalSize.Tiny))
          .onApprove(() => "")
          .onDeny(() => "");
      } else {
        let title: string = this.translateService.instant('modal.profile.noExp.title');
        let content: string = this.translateService.instant('modal.profile.noExp.connectionerror');
        this.modalService
          .open(new SimpleModal(title, content, ModalSize.Tiny))
          .onApprove(() => "")
          .onDeny(() => "");
      }
    }
  }

  /** visualizza la mappa
   */
  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }
  /** zoom a video
   * @param  {Experience} value
   */
  zoomOn(scheda: Experience) {
    // console.log(scheda);
    this.wgisservice.showEsperienzaByObj(scheda);
  }
  /** si ottiene l'exp della cache
   * @param  {Experience} value
   */
  getCacheExp(value: Experience) {
    this.savedExp.push(value);
  }
}